/**
 * Codemade OÜ
 *
 * Application frontend router
 *
 * @summary Application frontend router
 * @author Borka Martin Orlov
 *
 * Created at     : 2020-08-11 21:29:00
 * Last modified  : 2021-04-21 19:52:20
 */

import VueRouter from 'vue-router';
import Activity from './views/profile/Activity';
import Deal from './views/deal/Deal';
import Home from './views/Home';
import Leaderboards from './views/Leaderboards';
import Notifications from './views/profile/Notifications';
import Profile from './views/profile/Profile';
import Rewards from './views/profile/Rewards';
import Settings from './views/profile/Settings';
import Withdraw from './views/profile/Withdraw';
import ShareDeal from './views/ShareDeal';
import ShareVoucher from './views/ShareVoucher';
import ShareFreeStuff from './views/ShareFreeStuff';
import Status from './views/profile/Status';
import Content from './views/Content';
import CookiePolicy from './views/CookiePolicy';
import PrivacyPolicy from './views/PrivacyPolicy';
import Retailers from './views/Retailers';

const routes = [
    { name: 'home', path: '/', component: Home },
    { path: '/deals', component: Home, props: { typeFilter: 'Deal' } },
    { path: '/vouchers', component: Home, props: { typeFilter: 'Voucher Code' } },
	{ path: '/leaderboards', component: Leaderboards },
    { path: '/retailers', component: Retailers },
    { path: '/share', redirect: '/share/deal' },
	{ path: '/share/deal', component: ShareDeal },
    { path: '/share/voucher', component: ShareVoucher },
    { path: '/share/free', component: ShareFreeStuff },
	{ name: 'deal', path: '/deal/:id/:title', component: Deal },
    { name: 'privacy_policy', path: '/legal/privacy_policy', component: PrivacyPolicy },
    { name: 'cookie_policy', path: '/legal/cookie_policy', component: CookiePolicy },

    {
        path: '/profile',
        component: Profile,
        children: [
            { path: 'activity', component: Activity },
            { path: 'notifications', component: Notifications },
            { path: 'rewards', component: Rewards },
            { path: 'settings', component: Settings },
            { path: 'status', component: Status },
            { path: 'withdraw', component: Withdraw },
        ],
    },
    { path: '/more/:slug', component: Content },

    // This currently substitutes a 404
    // Just redirect back go home.
    { path: '/forgot-password', redirect: '/forgot-password' },
    { path: '*', redirect: '/' },
];

export default new VueRouter({
    mode: 'history',
    routes,
});
